import api from '../api';

const keepMeInformedService = {
  // DataTable-style fetch of notifications for logged guardian
  // Following Laravel PropertyViewingsController@getPropertyViewingInfoOfLoggedUser exactly
  // Laravel endpoint: POST /api/property_viewings/keep-me-inform
  getNotifications: async ({
    draw = 1,
    start = 0,
    length = 30,
    search = { value: '' },
    guardian_id = null,
  } = {}) => {
    try {
      // Laravel DataTable format - exact same as Laravel
      const body = { draw, start, length, search, guardian_id };
      const { data } = await api.post(
        '/property_viewings/keep-me-inform',
        body,
        { skipAuthLogout: true }
      );
      return data;
    } catch (error) {
      console.error('Error in getNotifications:', error);
      throw error;
    }
  },

  // Cancel a keep me informed notification
  // Following Laravel PropertyViewingsController@deleteInfo exactly
  // Laravel endpoint: DELETE /api/property_viewings/keep-informed/{id}/destroy
  cancelNotification: async (id, guardianId) => {
    try {
      const { data } = await api.delete(
        `/property_viewings/keep-informed/${id}/destroy`,
        {
          data: { guardian_id: guardianId },
          skipAuthLogout: true,
        }
      );
      return data;
    } catch (error) {
      console.error('Error in cancelNotification:', error);
      throw error;
    }
  },

  // Add keep me informed for a property
  // Following Laravel PropertyViewingsController@keepInformed exactly
  // Laravel endpoint: POST /api/property_viewings/keep-informed
  addKeepMeInformed: async (propertyId, guardianId) => {
    try {
      const { data } = await api.post(
        '/property_viewings/keep-informed',
        { property_id: propertyId, guardian_id: guardianId },
        { skipAuthLogout: true }
      );
      return data;
    } catch (error) {
      console.error('Error in addKeepMeInformed:', error);
      throw error;
    }
  },
};

export default keepMeInformedService;
